import * as React from "react"
import * as styles from "./styles.module.scss"
import { NextContext } from "next"
import { journeys } from "config/journeys"
import Footer from "components/Footer"
import Navbar from "components/Navbar"
import SideNav from "components/SideNav"
import StartJourney from "components/StartJourney"
import Document from "components/Document"
import { brand } from "config/brand"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import imgPurchasingAHomeLandscape from "images/start/purchasing-a-home-landscape.jpg"

const Start: React.FC = () => {
  return (
    <Document
      description={`Get started on your mortgage journey with ${brand.name}.`}
      pageClass="bet-StaticPage"
      pageId="startPage"
      thumbnail={imgPurchasingAHomeLandscape}
      title="Start your Mortgage Journey"
    >
      <Navbar />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.Navbar}>
        <div className={styles.start}>
          <div className={styles.pagePadding}>
            <ul className={styles.list}>
              <StartJourney
                journeyCategory={journeys.purchase}
                urlPrefix={"/start-"}
                journeyType="purchase"
                key="1"
              />
              <StartJourney
                journeyCategory={journeys.refinance}
                urlPrefix={"/start-"}
                journeyType="refinance"
                key="2"
              />
            </ul>
          </div>
        </div>
        <Footer />
      </PageWrapper>
    </Document>
  )
}

export default Start
